import React, { Component } from 'react'
import {
	Alert,
	Breadcrumb,
	BreadcrumbItem,
	Card,
	CardBody,
	CardFooter,
	Col,
	Container,
	Row
} from 'reactstrap';
import PropTypes from 'prop-types';

import AdminHomeContainerForm from '../AdminHomeContainerForm';
import AdminBroadcastAlertForm from '../AdminBroadcastAlertForm';

class AdminDashboardRoute extends Component {
	render() {
		return (
			<div>
				<Alert isOpen={this.props.loginAlert} toggle={this.props.handleLoginAlert} color="info">
					Welcome back, {this.props.givenName}! Your last login was {this.props.lastLogin}.
				</Alert>

				<Breadcrumb tag="ol">
					<BreadcrumbItem tag="li">
						<a>Ecofresh Admin CP</a>
					</BreadcrumbItem>
					<BreadcrumbItem active tag="li">Dashboard</BreadcrumbItem>
				</Breadcrumb>

				<Row>
					<Col xs="4">
						<Card className="mb-3">
							<div className="card-header">
								<i className="fa fa-exclamation-circle"></i>{' '}
								Edit Broadcast Alert
							</div>
							<CardBody>
								<Container>
									<AdminBroadcastAlertForm />
								</Container>
							</CardBody>
							<CardFooter className="small text-muted">Updated yesterday at 11:59 PM</CardFooter>
						</Card>
					</Col>
					<Col xs="8">
						<Card className="mb-3">
							<div className="card-header">
								<i className="fa fa-info-circle"></i>{' '}
								Edit Home Container
							</div>
							<CardBody>
								<Container style={{maxWidth: "500px"}}>
									<AdminHomeContainerForm />
								</Container>
							</CardBody>
							<CardFooter className="small text-muted">Updated yesterday at 11:59 PM</CardFooter>
						</Card>
					</Col>
				</Row>
			</div>
		);
	}
};

AdminDashboardRoute.propTypes = {
  handleLoginAlert: PropTypes.func
};

export default AdminDashboardRoute


// WEBPACK FOOTER //
// ./src/admin-components/routes/AdminDashboardRoute.js